/**
 * Which build this origin deploys now — `/version.json` — read without the
 * rest of auto-update (PostHog, the update toast), so the error page can ask
 * too.
 */

// Same-origin, RELATIVE on purpose. The client compares its baked
// __APP_BUILD_TIME__ against the version.json served by the SAME deployment it
// loaded from, so each origin self-checks in isolation: a production release
// (www.flashka.ai) never makes a PR preview (*.vercel.app) — or localhost —
// think it's stale, and a preview only prompts when that PR itself rebuilds.
// Do NOT change this to an absolute prod URL: it would make every preview and
// local build compare against production and falsely prompt "update available".
const VERSION_URL = '/version.json';

export type DeployedBuild = { buildId: string; buildTime: number };

/** The build this origin serves now, or null when version.json is unreadable. */
export async function fetchDeployedBuild(): Promise<DeployedBuild | null> {
  try {
    const res = await fetch(`${VERSION_URL}?_=${Date.now()}`, { cache: 'no-store' });
    if (!res.ok) return null;
    const data = (await res.json()) as { buildId?: unknown; buildTime?: unknown };
    if (typeof data.buildId !== 'string' || typeof data.buildTime !== 'number') {
      return null;
    }
    return { buildId: data.buildId, buildTime: data.buildTime };
  } catch {
    return null;
  }
}
